import React, { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
// import classes from './GuidanceTools/guidanceTools.module.css';
import { TreasureBox } from './GuidanceTools/TreasureBox';
// import { Notebook } from './GuidanceTools/Notebook';
import { Dumbbell } from './GuidanceTools/Dumbbell';
import { RunnerType } from 'adapters/repositories/typeDefinition';
import { Crown } from './GuidanceTools/Crown';
import { Letter } from './GuidanceTools/Letter';
import { SearchButton } from './GuidanceTools/SearchButton';
import { onboardType } from './GuidanceTools/type';
import { putRunnerInfo } from 'v1apiRequest';
import { returnThumbnailForGrade } from '../func/returnThumbnailForTheGrade';

type Props = {
  runner: RunnerType;
  onboardState: onboardType;
  onCloseTreasureBox: () => void;
};

export const GuidanceTools: FC<Props> = memo(
  ({ runner, onboardState, onCloseTreasureBox }) => {
    // 毎回オンボーディングの段階を確認する
    const navigate = useNavigate();
    const latestExamVideo =
      (runner.latest_exam_video.length > 0 && runner.latest_exam_video[0]) ||
      null;
    const onClickLetter = useCallback(() => {
      if (!!latestExamVideo && runner.latest_exam_video[0].checked_by_boss) {
        const nextState =
          (runner.stay_times > 0 && 'beforeChallenge') || 'beforeMsg';
        localStorage.setItem(String(runner.id), nextState);
        putRunnerInfo({ id: runner.id, onboarding: nextState });
        navigate(`/logs/result/${latestExamVideo.id}`);
      }
      return;
    }, [runner]);

    console.log(returnThumbnailForGrade(runner));

    return (
      <>
        {/* <Notebook runner={runner} /> */}
        <TreasureBox
          runner={runner}
          onClickFunc={onCloseTreasureBox}
          onboardState={onboardState}
        />
        <Dumbbell onboardState={onboardState} />
        <Crown onboardState={onboardState} />
        <SearchButton onboardState={onboardState} video={latestExamVideo} />
        <Letter onClickFunc={onClickLetter} onboardState={onboardState} />
      </>
    );
  },
);
